// Sport-specific UI labels.
//
// The sidebar (and other sport-aware UI) reads labels through `getSportLabel`.
// Most labels are the same across sports; only the ones that need to differ
// go in `OVERRIDES`. Anything not overridden falls back to `DEFAULTS`.
//
// To customize a label for a sport, add the key under that sport in OVERRIDES.
// To add a new label, add it to DEFAULTS (and to LabelKey).

export type SportLabelKey = 'venues';

const DEFAULTS: Record<SportLabelKey, string> = {
  venues: 'Venues',
};

const OVERRIDES: Record<string, Partial<Record<SportLabelKey, string>>> = {
  basketball: { venues: 'Courts' },
  pickleball: { venues: 'Courts' },
  tennis: { venues: 'Courts' },
  volleyball: { venues: 'Courts' },
  badminton: { venues: 'Courts' },
  soccer: { venues: 'Fields' },
  football: { venues: 'Fields' },
  baseball: { venues: 'Fields' },
  softball: { venues: 'Fields' },
  lacrosse: { venues: 'Fields' },
  rugby: { venues: 'Fields' },
  hockey: { venues: 'Rinks' },
  golf: { venues: 'Courses' },
  track: { venues: 'Tracks' },
  swimming: { venues: 'Pools' },
  bowling: { venues: 'Lanes' },
};

export function getSportLabel(sport: string | null | undefined, key: SportLabelKey): string {
  const sportKey = sport ?? '';
  return OVERRIDES[sportKey]?.[key] ?? DEFAULTS[key];
}
